import { createContext, useContext, useState, useEffect } from "react";

const LibraryContext = createContext();

export function LibraryProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [libraryBooks, setLibraryBooks] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [itemsLimit, setItemsLimit] = useState(10);


    useEffect(() => {
        async function fetchLibrary() {
            // setLoading(true);
            try {
                if (searchQuery) {
                    // Fetch all pages when searching
                    let page = 1;
                    let allResults = [];
                    let hasMorePages = true;

                    while (hasMorePages) {
                        const booksData = await fetch(
                            `${process.env.REACT_APP_MASAR_API_URL}/library/books?page=${page}`,
                            // fixed by github copilot (Useless conditional) the old line was (to verify):
                            // `${process.env.REACT_APP_MASAR_API_URL}/library/books?${searchQuery ? `page=${page}` : `page=${page}&limit=${itemsLimit}${selectedCategory ? `&categoryId=${selectedCategory}` : ''}`}`,
                            {
                                method: "GET",
                                headers: {
                                    "accept": "*/*"
                                }
                            }
                        );
                        const response = await booksData.json();

                        if (response.data?.result) {
                            allResults = [...allResults, ...response.data.result];
                            if (page >= response.data.paginationInfo.totalPagesCount) {
                                hasMorePages = false;
                            }
                        } else {
                            hasMorePages = false;
                        }
                        page++;
                    }
                    // Filter results based on search query
                    const filteredResults = allResults.filter(book =>
                        book.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        book.publishedDate.toString().includes(searchQuery.toLowerCase()) ||
                        book.author.toLowerCase().includes(searchQuery.toLowerCase())
                    );
                    setLibraryBooks({
                        isSuccess: true,
                        data: {
                            result: filteredResults,
                            paginationInfo: {
                                pageNumber: 1,
                                totalCount: filteredResults.length,
                                totalPagesCount: 1
                            }
                        }
                    });
                } else {
                    // Regular pagination without search
                    const booksData = await fetch(
                        `${process.env.REACT_APP_MASAR_API_URL}/library/books?page=${currentPage}&limit=${itemsLimit}${selectedCategory ? `&categoryId=${selectedCategory}` : ''}`,
                        {
                            method: "GET",
                            headers: {
                                "accept": "*/*"
                            }
                        }
                    );
                    const responseData = await booksData.json();
                    setLibraryBooks(responseData);
                }
            } catch (err) {
                console.error("Error fetching books:", err);
                setLibraryBooks(null);
            } finally {
                setLoading(false);
            }
        }

        fetchLibrary();
    }, [currentPage, selectedCategory, searchQuery, itemsLimit]);

    return (
        <LibraryContext.Provider
            value={{
                loading, selectedCategory, setSelectedCategory,
                libraryBooks, setLibraryBooks,
                currentPage, setCurrentPage,
                searchQuery, setSearchQuery,
                itemsLimit, setItemsLimit
            }}>
            {children}
        </LibraryContext.Provider>
    );
}

export function useLibrary() {
    return useContext(LibraryContext);
}